<template>
  <Transition name="banner">
    <div
      v-if="visible"
      class="cookie-banner fixed bottom-0 left-0 right-0 z-[9998] p-4 md:p-6"
    >
      <div class="max-w-7xl mx-auto">
        <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-white/15 rounded-2xl shadow-2xl p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-5">
          <!-- Icono + texto -->
          <div class="flex items-start gap-4 flex-1">
            <div class="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center text-primary flex-shrink-0 mt-0.5">
              <span class="material-symbols-outlined text-2xl">cookie</span>
            </div>
            <div>
              <p class="font-bold text-slate-900 dark:text-white text-base mb-1">Usamos cookies</p>
              <p class="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                Utilizamos cookies técnicas y de preferencia para mejorar tu experiencia. No rastreamos tu actividad con fines publicitarios.
                <RouterLink to="/politica-de-cookies" class="text-primary font-semibold hover:underline ml-1">Ver política de cookies</RouterLink>
              </p>
            </div>
          </div>
          <!-- Botones -->
          <div class="flex items-center gap-3 flex-shrink-0">
            <button
              @click="reject"
              class="h-10 px-5 text-sm font-semibold text-slate-700 dark:text-slate-300 border border-slate-300 dark:border-white/20 rounded-full hover:bg-slate-100 dark:hover:bg-white/10 transition-all">
              Rechazar
            </button>
            <button
              @click="accept"
              class="h-10 px-6 text-sm font-bold bg-primary text-white rounded-full hover:opacity-90 shadow-lg shadow-primary/25 transition-all active:scale-95">
              Aceptar cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { RouterLink } from 'vue-router'

const COOKIE_KEY = 'agsoft_cookie_consent'
const visible = ref(false)

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`
}

function accept() {
  setCookie(COOKIE_KEY, 'accepted', 365)
  visible.value = false
}

function reject() {
  setCookie(COOKIE_KEY, 'rejected', 180)
  visible.value = false
}

onMounted(() => {
  if (!getCookie(COOKIE_KEY)) {
    setTimeout(() => { visible.value = true }, 1200)
  }
})
</script>

<style scoped>
.banner-enter-active {
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.4s ease;
}
.banner-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.banner-enter-from {
  transform: translateY(100%);
  opacity: 0;
}
.banner-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>